import { baseUrl } from './routes';

export class NotesRoutes {
  static get view(): string {
    return `${baseUrl}/notes-list`;
  }
}
